module.exports = __webpack_public_path__ + "static/media/Auto.28c227da.mp3";